import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsAcrissDrawer, isOpenUserSettingsAcrissDrawer, userSettingAcrissFormData } from "../../../@signals"
import UserSettingAcrissDrawerColor from "./Color"
import UserSettingAcrissDrawerAcriss from "./Acriss"
import UserSettingAcrissDrawerSubmit from "./Submit"


export default function UserSettingAcrissDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsAcrissDrawer.value ? 'Edit ACRISS' : 'New ACRISS'}
		isOpen={isOpenUserSettingsAcrissDrawer.value}
		controller={() => userSettingAcrissFormData.value = { }}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingAcrissDrawerAcriss />
			</Grid>

			<Grid item xs={12}>
				<UserSettingAcrissDrawerColor />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingAcrissDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}